import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NSSelectModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { RailEmissionComponent } from '@ruby/modules/rail-emission/components/rail-emission.component';
import { RailEmissionContainer } from '@ruby/modules/rail-emission/containers/rail-emission.container';
import { RailEmissionRoutingModule } from '@ruby/modules/rail-emission/rail-emission-routing.module';
import { RailEmissionEffects } from '@ruby/modules/rail-emission/store/effects/rail-emission.effects';
import * as fromRailEmission from '@ruby/modules/rail-emission/store/reducers/rail-emission.reducer';

@NgModule({
  declarations: [
    RailEmissionContainer,
    RailEmissionComponent
  ],
  imports: [
    CommonModule,
    EffectsModule.forFeature([RailEmissionEffects]),
    RailEmissionRoutingModule,
    StoreModule.forFeature(fromRailEmission.featureKey, fromRailEmission.reducer),
    NSSelectModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    FormsModule,
    NSSkeletonModule,
    NgxExtendedPdfViewerModule,
    MatSelectModule,
    MatCheckboxModule,
    MatChipsModule,
    MatTooltipModule
  ]
})
export class RailEmissionModule {}
